import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const resetDeletingStatus = (
  state: StationsState,
  action: PayloadAction<StationsState['favouriteStations']['deletingStatus']>
) => {
  state.favouriteStations.deletingStatus = action.payload;
};
